// extracted by mini-css-extract-plugin
export var bannerContainer = "PageBanner-module__bannerContainer___Id7XR";
export var hidden = "PageBanner-module__hidden___QnSZ1";
export var pageBannerShadowLightMode = "#d7d7d7";
export var visible = "PageBanner-module__visible___jxv0m";